import GetSelectOptions from "./GetSelectOptions";

export default GetSelectOptions;
